import { render, staticRenderFns } from "./withdrawals-investor-module.vue?vue&type=template&id=b4be60de&scoped=true&"
import script from "./withdrawals-investor-module.vue?vue&type=script&lang=js&"
export * from "./withdrawals-investor-module.vue?vue&type=script&lang=js&"
import style0 from "./withdrawals-investor-module.vue?vue&type=style&index=0&id=b4be60de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4be60de",
  null
  
)

export default component.exports